<template>
  <v-item-group class="full-width">
    <v-row no-gutters style="overflow: scroll; height: 150%">
      <v-col v-for="(bird, id) in birds" :key="id" cols="4" md="4">
        <v-item v-slot="{ active, toggle }">
          <v-hover v-slot="{ hover }">
            <v-card
              v-if="active"
              flat
              tile
              elevation="0"
              :class="{ 'on-hover': hover }"
              :color="active ? 'white' : bird.color"
              class="align-center mx-auto"
              dark
              :height="cardHeight"
            >
              <v-window
                v-model="onboarding"
                style="height: 100% !important; width: 100% !important"
              >
                <v-window-item>
                  <div align="left">
                    <v-btn
                      @click="toggle"
                      class="close-btn"
                      icon
                      color="transparent"
                      elevation="0"
                      style="z-index: 9999"
                      ><v-icon color="black">mdi-close</v-icon></v-btn
                    >
                    <v-row>
                      <div class="justify-vertically-start">
                        <h1 class="mb-2 mr-2">
                          {{ bird.name }}
                          <span class="italic">
                            {{ bird.nameLatin }}
                          </span>
                        </h1>

                        <h2>{{ bird.description }}</h2>
                      </div>
                    </v-row>
                    <v-row>
                      <v-btn
                        rounded
                        icon
                        text
                        class="play-btn"
                        @click="playSound(bird.url)"
                        style="z-index: 9999"
                      >
                        <img
                          src="../assets/play.svg"
                          alt="play"
                          style="width: 50px"
                        />
                      </v-btn>
                    </v-row>
                  </div>
                </v-window-item>
                <v-window-item>
                  <div align="left">
                    <v-btn
                      @click="toggle"
                      class="close-btn"
                      icon
                      color="transparent"
                      elevation="0"
                      style="z-index: 9999"
                      ><v-icon color="black">mdi-close</v-icon></v-btn
                    >
                    <v-card-title>
                      <div class="justify-vertically-start mb-3">
                        <h1>
                          {{ bird.name }}
                          <span class="italic">
                            {{ bird.nameLatin }}
                          </span>
                        </h1>
                      </div>
                    </v-card-title>
                    <v-card-text class="mt-5">
                      <div
                        v-for="(tipp, index) in bird.tipps"
                        :key="index"
                        style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                          justify-content: flex-start;
                          margin-bottom: 1vh;
                        "
                      >
                        <div
                          style="
                            width: 25px;
                            display: flex;
                            align-items: center;
                            justify: center;
                          "
                        >
                          <img
                            class="ma-auto"
                            :src="
                              require('../assets/icons/' +
                                Object.keys(tipp)[0] +
                                '.svg')
                            "
                            alt="point"
                            style="height: 20px"
                          />
                        </div>
                        <div style="text-align: center">
                          <p class="ma-auto ml-5">
                            {{ Object.values(tipp)[0] }}
                          </p>
                        </div>
                      </div>
                    </v-card-text>
                  </div>
                </v-window-item>
              </v-window>

              <v-card-actions
                class="justify-end"
                style="
                  width: 100%;
                  height: 60px;
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  z-index: 9997;
                "
              >
                <v-item-group
                  v-model="onboarding"
                  class="text-center"
                  mandatory
                >
                  <v-item v-for="n in 2" :key="n" v-slot="{ active, toggle }">
                    <v-btn
                      :input-value="active"
                      @click="toggle"
                      rounded
                      :disabled="freezePlayBtn"
                      icon
                      x-small
                    >
                      <v-icon :color="active ? 'black' : 'grey'" small
                        >mdi-record</v-icon
                      >
                    </v-btn>
                  </v-item>
                </v-item-group>
              </v-card-actions>
            </v-card>
            <v-card
              v-else
              :class="{ 'on-hover': hover }"
              :color="active ? 'white' : bird.color"
              class="d-flex align-center mx-auto"
              dark
              :height="cardHeight"
            >
              <div align="center" style="text-align: center">
                <img
                  :src="'./bird-pics/' + bird.url + '.png'"
                  class="img-bird"
                />
                <div class="bird-name" @click="toggle">
                  <div>
                    <h5>{{ bird.name }}</h5>
                    <h5 class="italic">
                      {{ bird.nameLatin }}
                    </h5>
                  </div>
                </div>
              </div>
            </v-card>
          </v-hover>
        </v-item>
      </v-col>
    </v-row>
  </v-item-group>
</template>

<script>
import birdsData from "../bird_infos.json";

export default {
  name: "Encyclopedia",
  props: {
    players: Object,
    musicOn: Boolean,
  },
  data() {
    return {
      onboarding: 0,
      activePage: 0,
      freezePlayBtn: false,
      birds: birdsData,
      cardHeight: 0.6 * (window.innerWidth / 3),
    };
  },

  methods: {
    playSound(name) {
      let wasMuted;
      this.freezePlayBtn = true;
      this.musicOn ? (wasMuted = false) : (wasMuted = true);
      wasMuted ? null : this.$emit("toggle-music");
      this.players.player(name).start();
      setTimeout(() => {
        wasMuted ? null : this.$emit("toggle-music");
        this.freezePlayBtn = false;
      }, 7000);
    },
  },
};
</script>

<style scoped>
.bird-name {
  width: 300px;
  min-height: 200px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;

  /* position the div in center */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
p {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: max(17px, 1.3vw);
  display: flex;
  letter-spacing: 0.05em;
  text-align: left;
  color: #000000;
}
.container {
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
}
.full-width {
  max-width: none !important;
  padding: 0;
  width: 100% !important;
}
.v-card {
  border-radius: 0;
}
.v-card:not(.on-hover) h5 {
  opacity: 1;
}
.v-card:not(.on-hover) .img-bird {
  opacity: 0;
}
.img-bird {
  width: 30%;
  opacity: 1;
}
h1 {
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.05em;
  word-break: normal;
  color: #000000;
  width: 100%;
}
h5 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  letter-spacing: 0.05em;
  color: #000000;
  word-break: normal;
  opacity: 0;
  margin: auto;
}
.italic {
  font-weight: normal;
  font-style: italic;
}
h2 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 17px;
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.05em;
  color: #000000;
  white-space: pre-wrap;
  word-break: normal;
  width: 90%;
}
.bottom {
  position: fixed;
  bottom: 0;
}
.v-card {
  justify-content: center;
}
.round {
  border-radius: 50% !important;
}
.play-btn {
  position: absolute;
  align-self: center;
  bottom: 10%;
  left: 45%;
}
.justify-vertically-start {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: absolute;
  top: 2%;
  left: 2%;
}
.close-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.white-bg {
  background-color: white !important;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
  border-radius: 0 !important;
}
</style>